import { CALLING_COUNTRY_CODES } from '@wix/form-validator';
const allCallingCountryCodes = Object.keys(CALLING_COUNTRY_CODES);

// TODO: strongly type all params
const MinMaxLengthMapper = validation => {
  var _validation$string, _validation$string2;
  return {
    maxLength: validation == null || (_validation$string = validation.string) == null ? void 0 : _validation$string.maxLength,
    minLength: validation == null || (_validation$string2 = validation.string) == null ? void 0 : _validation$string2.minLength
  };
};
const MinMaxItemsMapper = validation => {
  var _validation$array, _validation$array2;
  return {
    minItems: validation == null || (_validation$array = validation.array) == null ? void 0 : _validation$array.minItems,
    maxItems: validation == null || (_validation$array2 = validation.array) == null ? void 0 : _validation$array2.maxItems
  };
};
const MinMaxValuesMapper = validation => {
  var _validation$predefine, _validation$predefine2;
  return {
    minValue: validation == null || (_validation$predefine = validation.predefined) == null || (_validation$predefine = _validation$predefine.paymentOptions) == null || (_validation$predefine = _validation$predefine.products) == null || (_validation$predefine = _validation$predefine[0]) == null ? void 0 : _validation$predefine.dynamicPriceOptions.minPrice,
    maxValue: validation == null || (_validation$predefine2 = validation.predefined) == null || (_validation$predefine2 = _validation$predefine2.paymentOptions) == null || (_validation$predefine2 = _validation$predefine2.products) == null || (_validation$predefine2 = _validation$predefine2[0]) == null ? void 0 : _validation$predefine2.dynamicPriceOptions.maxPrice
  };
};
const AcceptedDatesMapper = validation => {
  var _validation$string3, _validation$string4;
  return {
    acceptedDates: (validation == null || (_validation$string3 = validation.string) == null || (_validation$string3 = _validation$string3.dateOptions) == null ? void 0 : _validation$string3.minimum) === '$now' ? 'future' : (validation == null || (_validation$string4 = validation.string) == null || (_validation$string4 = _validation$string4.dateOptions) == null ? void 0 : _validation$string4.maximum) === '$now' ? 'past' : 'all'
  };
};
const CustomOptionMapper = props => {
  const {
    addOther,
    addOtherLabel,
    addOtherPlaceholder
  } = props;
  return {
    customOption: addOther ? {
      label: addOtherLabel,
      placeholder: addOtherPlaceholder
    } : undefined
  };
};

// Convert ValidationError to error message string
const ErrorMapper = error => {
  if (!error) {
    return undefined;
  }
  return error.errorMessage || 'Validation error';
};
const BaseMapper = props => {
  const {
    hideLabel,
    error,
    showLabel,
    ...rest
  } = props;
  return {
    ...rest,
    showLabel: hideLabel === undefined ? true : !hideLabel,
    error: ErrorMapper(error)
  };
};
const TextFieldMapper = props => ({
  ...props,
  ...MinMaxLengthMapper(props == null ? void 0 : props.validation),
  ...BaseMapper(props)
});
const TextAreaMapper = props => ({
  ...props,
  ...MinMaxLengthMapper(props == null ? void 0 : props.validation),
  ...BaseMapper(props)
});
const PhoneInputMapper = props => {
  var _validation$string5;
  const {
    defaultCountry,
    defaultCountryCode,
    validation
  } = props;
  const allowedCountryCodes = validation == null || (_validation$string5 = validation.string) == null || (_validation$string5 = _validation$string5.phoneOptions) == null ? void 0 : _validation$string5.allowedCountryCodes;
  return {
    ...props,
    ...BaseMapper(props),
    defaultCountryCode: defaultCountry ?? defaultCountryCode,
    countryCodes: allowedCountryCodes && allowedCountryCodes.length > 0 ? allowedCountryCodes : allCallingCountryCodes
  };
};
const MultilineAddressMapper = props => {
  var _view$fieldSettings, _validation$predefine3;
  const {
    view,
    validation
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    showAddressLine2: view == null || (_view$fieldSettings = view.fieldSettings) == null || (_view$fieldSettings = _view$fieldSettings.addressLine2) == null ? void 0 : _view$fieldSettings.show,
    addressLine2Required: validation == null || (_validation$predefine3 = validation.predefined) == null || (_validation$predefine3 = _validation$predefine3.multilineAddressOptions) == null || (_validation$predefine3 = _validation$predefine3.fields) == null || (_validation$predefine3 = _validation$predefine3.addressLine2) == null ? void 0 : _validation$predefine3.required
  };
};
const DateInputMapper = props => {
  const {
    hidePlaceholder,
    validation
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    ...AcceptedDatesMapper(validation),
    showPlaceholder: hidePlaceholder === undefined ? true : !hidePlaceholder
  };
};
const DatePickerMapper = props => {
  const {
    validation
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    ...AcceptedDatesMapper(validation)
  };
};
const DateTimeInputMapper = props => {
  const {
    hidePlaceholder,
    validation
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    ...AcceptedDatesMapper(validation),
    showPlaceholder: hidePlaceholder === undefined ? true : !hidePlaceholder
  };
};
const FileUploadMapper = props => {
  const {
    valueSliderLimit,
    uploadFileFormats
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    maxFiles: valueSliderLimit,
    allowedFileFormats: uploadFileFormats
  };
};
const NumberInputMapper = props => BaseMapper(props);
const CheckboxMapper = props => {
  const {
    error,
    ...rest
  } = props;
  return {
    ...rest,
    error: ErrorMapper(error)
  };
};
const SignatureMapper = props => {
  const {
    uploadEnabled
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    imageUploadEnabled: uploadEnabled
  };
};
const RatingInputMapper = props => BaseMapper(props);
const RadioGroupMapper = props => {
  return {
    ...props,
    ...BaseMapper(props),
    ...CustomOptionMapper(props)
  };
};
const CheckboxGroupMapper = props => {
  const {
    validation
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    ...CustomOptionMapper(props),
    ...MinMaxItemsMapper(validation)
  };
};
const DropdownMapper = props => BaseMapper(props);
const TagsMapper = props => {
  const {
    validation
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    ...CustomOptionMapper(props),
    ...MinMaxItemsMapper(validation)
  };
};
const TimeInputMapper = props => {
  const {
    hidePlaceholder
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    showPlaceholder: hidePlaceholder === undefined ? true : !hidePlaceholder
  };
};
const TextMapper = props => props;
const SubmitButtonMapper = props => {
  return {
    ...props
  };
};
const ProductListMapper = props => {
  return {
    ...props,
    ...BaseMapper(props),
    ...MinMaxItemsMapper(props == null ? void 0 : props.validation)
  };
};
const FixedPaymentMapper = props => {
  var _validation$predefine4, _paymentValidation$fi;
  const {
    validation,
    hideLabel,
    showLabel,
    ...rest
  } = props;
  const paymentValidation = validation == null || (_validation$predefine4 = validation.predefined) == null || (_validation$predefine4 = _validation$predefine4.paymentOptions) == null || (_validation$predefine4 = _validation$predefine4.products) == null ? void 0 : _validation$predefine4[0];
  const fixedPaymentValue = paymentValidation == null || (_paymentValidation$fi = paymentValidation.fixedPriceOptions) == null ? void 0 : _paymentValidation$fi.price;
  return {
    ...rest,
    validation,
    showLabel: hideLabel === undefined ? true : !hideLabel,
    amount: fixedPaymentValue
  };
};
const PaymentInputMapper = props => {
  const {
    validation
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    ...MinMaxValuesMapper(validation)
  };
};
const DonationMapper = props => {
  return {
    ...props,
    ...BaseMapper(props),
    ...CustomOptionMapper(props)
  };
};
const AppointmentMapper = props => BaseMapper(props);
const ImageChoiceMapper = props => {
  const {
    isMultipleAnswers,
    choiceImageResize
  } = props;
  return {
    ...props,
    ...BaseMapper(props),
    multiple: isMultipleAnswers,
    imageAspectRatio: choiceImageResize
  };
};
const DefaultMapper = props => {
  const {
    error,
    ...rest
  } = props;
  return {
    ...rest,
    error: ErrorMapper(error)
  };
};
export const FIELD_PROPS_MAPPERS = {
  TEXT_INPUT: TextFieldMapper,
  TEXT_AREA: TextAreaMapper,
  NUMBER_INPUT: NumberInputMapper,
  URL_INPUT: TextFieldMapper,
  DATE_INPUT: DateInputMapper,
  DATE_PICKER: DatePickerMapper,
  DATE_TIME_INPUT: DateTimeInputMapper,
  TIME_INPUT: TimeInputMapper,
  CONTACTS_COMPANY: TextFieldMapper,
  CONTACTS_POSITION: TextFieldMapper,
  CONTACTS_TAX_ID: TextFieldMapper,
  CONTACTS_FIRST_NAME: TextFieldMapper,
  CONTACTS_LAST_NAME: TextFieldMapper,
  CONTACTS_EMAIL: TextFieldMapper,
  CONTACTS_BIRTHDATE: DateInputMapper,
  CONTACTS_PHONE: PhoneInputMapper,
  CONTACTS_ADDRESS: TextFieldMapper,
  CONTACTS_SUBSCRIBE: CheckboxMapper,
  RADIO_GROUP: RadioGroupMapper,
  CHECKBOX: CheckboxMapper,
  CHECKBOX_GROUP: CheckboxGroupMapper,
  DROPDOWN: DropdownMapper,
  TAGS: TagsMapper,
  QUIZ_IMAGE_CHOICE: ImageChoiceMapper,
  QUIZ_MULTI_CHOICE: CheckboxGroupMapper,
  QUIZ_SINGLE_CHOICE: RadioGroupMapper,
  QUIZ_SHORT_TEXT: TextFieldMapper,
  QUIZ_LONG_TEXT: TextAreaMapper,
  QUIZ_NUMBER: NumberInputMapper,
  QUIZ_FILE_UPLOAD: FileUploadMapper,
  DEXT_TEXT_INPUT: TextFieldMapper,
  DEXT_TEXT_AREA: TextAreaMapper,
  DEXT_DROPDOWN: DropdownMapper,
  DEXT_URL_INPUT: TextFieldMapper,
  DEXT_RADIO_GROUP: RadioGroupMapper,
  DEXT_NUMBER_INPUT: NumberInputMapper,
  DEXT_CHECKBOX: CheckboxMapper,
  DEXT_CHECKBOX_GROUP: CheckboxGroupMapper,
  DEXT_EMAIL: TextFieldMapper,
  DEXT_PHONE: PhoneInputMapper,
  DEXT_RATING_INPUT: RatingInputMapper,
  DEXT_DATE_PICKER: DatePickerMapper,
  DEXT_DATE_TIME_INPUT: DateTimeInputMapper,
  DEXT_TAGS: TagsMapper,
  MULTILINE_ADDRESS: MultilineAddressMapper,
  MLA_COUNTRY: DropdownMapper,
  MLA_CITY: TextFieldMapper,
  MLA_ADDRESS_LINE: TextFieldMapper,
  MLA_ADDRESS_LINE_2: TextFieldMapper,
  MLA_POSTAL_CODE: TextFieldMapper,
  MLA_SUBDIVISION: DropdownMapper,
  MLA_STREET_NAME: TextFieldMapper,
  MLA_STREET_NUMBER: TextFieldMapper,
  MLA_APARTMENT: TextFieldMapper,
  FULL_NAME: TextFieldMapper,
  FULL_NAME_FIRST_NAME: TextFieldMapper,
  FULL_NAME_LAST_NAME: TextFieldMapper,
  ECOM_ADDITIONAL_INFO: TextAreaMapper,
  ECOM_ADDRESS: TextFieldMapper,
  ECOM_FULL_NAME: TextFieldMapper,
  ECOM_PHONE: PhoneInputMapper,
  ECOM_COMPANY_NAME: TextFieldMapper,
  ECOM_EMAIL: TextFieldMapper,
  ECOM_SUBSCRIPTION: CheckboxMapper,
  ECOM_CONTACT_DETAILS: TextMapper,
  ECOM_SHIPPING_DETAILS: TextMapper,
  BOOKINGS_FIRST_NAME: TextFieldMapper,
  BOOKINGS_LAST_NAME: TextFieldMapper,
  BOOKINGS_EMAIL: TextFieldMapper,
  BOOKINGS_PHONE: PhoneInputMapper,
  BOOKINGS_ADDRESS: TextFieldMapper,
  BOOKINGS_HEADER: TextMapper,
  BOOKINGS_RICH_TEXT: TextMapper,
  BOOKINGS_LOGIN_BAR: DefaultMapper,
  APPOINTMENT: AppointmentMapper,
  SERVICES_DROPDOWN: DropdownMapper,
  SERVICES_MULTI_CHOICE: CheckboxGroupMapper,
  PRODUCT_LIST: ProductListMapper,
  FIXED_PAYMENT: FixedPaymentMapper,
  PAYMENT_INPUT: PaymentInputMapper,
  DONATION: DonationMapper,
  EVENTS_RSVP: RadioGroupMapper,
  EVENTS_REPEATER: TextMapper,
  FILE_UPLOAD: FileUploadMapper,
  SIGNATURE: SignatureMapper,
  RATING_INPUT: RatingInputMapper,
  VAT_ID: TextFieldMapper,
  NESTED_FORM: DefaultMapper,
  HEADER: TextMapper,
  RICH_TEXT: TextMapper,
  SUBMIT_BUTTON: SubmitButtonMapper,
  PASSWORD: DefaultMapper
};
//# sourceMappingURL=public-props-map.js.map